import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const CompletedIcon = ({ width = "96", height = "96" }: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="96" height="96" rx="48" fill="#E9F7EF" />
        <rect x="16" y="16" width="64" height="64" rx="32" fill="#D4EFDF" />
        <path
          d="M37.3337 48C37.3337 42.1089 42.1093 37.3333 48.0003 37.3333C53.8914 37.3333 58.667 42.1089 58.667 48C58.667 53.8911 53.8914 58.6667 48.0003 58.6667C42.1093 58.6667 37.3337 53.8911 37.3337 48ZM48.0003 34.6667C40.6365 34.6667 34.667 40.6362 34.667 48C34.667 55.3637 40.6365 61.3333 48.0003 61.3333C55.3641 61.3333 61.3337 55.3637 61.3337 48C61.3337 40.6362 55.3641 34.6667 48.0003 34.6667ZM55.2765 44.6095L53.3909 42.7238L46.667 49.4477L42.9431 45.7239L41.0575 47.6095L46.667 53.2189L55.2765 44.6095Z"
          fill="#27AE60"
        />
      </svg>
    </IconWrapper>
  );
};
